export const SOCIAL_LISTENING_POST_VIEW_SETTING =
  'socialListeningPostViewSetting';
export const SOCIAL_LISTENING_LIST_FILTERS = 'socialListeningListFilters';
export const SOCIAL_LISTENING_LIST_SORT_BY = 'socialListeningListSortBy';
export const SOCIAL_LISTENING_TOPIC_IDS_FILTER =
  'socialListeningTopicIdsFilter';
